import member1 from "@/assets/member-1.jpg";
import member2 from "@/assets/member-2.jpg";
import member3 from "@/assets/member-3.jpg";
import member4 from "@/assets/member-4.jpg";
import member5 from "@/assets/member-5.jpg";
import member6 from "@/assets/member-6.jpg";
interface CrewMember {
  name: string;
  instrument: string;
  image: string;
}
const crewMembers: CrewMember[] = [{
  name: "Tommy Waves",
  instrument: "Lead Guitar",
  image: member1
}, {
  name: "Rick Harmony",
  instrument: "Keys",
  image: member2
}, {
  name: "Danny Sunset",
  instrument: "Drums",
  image: member3
}, {
  name: "Lisa Breeze",
  instrument: "Vocals",
  image: member4
}, {
  name: "Mike Anchor",
  instrument: "Bass",
  image: member5
}, {
  name: "Steve Sails",
  instrument: "Saxophone",
  image: member6
}];
const CrewSection = () => {
  return null;
};
export default CrewSection;